import React from 'react'
import IntroSlide from './IntroSlide'
import TitleSlide from './TitleSlide'
import BlankSlide from './BlankSlide'
import SplitSlide from './SplitSlide'
import SplitSlideReverse from './SplitSlideReverse'
import SplitSlideStory from './SplitSlideStory'
import SplitSlideStoryReverse from './SplitSlideStoryReverse'
import SplitSlideStoryLink from './SplitSlideStoryLink'
import ImageSlide from './ImageSlide'
import LinksSlide from './LinksSlide'
import ListSlide from './ListSlide'
import PhotographerSlide from './PhotographerSlide';


function isPlainObject(input){
    return input && !Array.isArray(input) && typeof input === 'object';
 }


function traverse(object) {
    for (const key in object) {
        
        if(isPlainObject(object[key])) {
            traverse(object[key])
        } else if(Array.isArray(object[key])) {
            object[key] = object[key].map((val, index) => <div key={index}>{ val }</div>)
        }

    }
}


function slideParser(slide, index, lastSlide, activeSlide) {

    if(slide.layout !== 'intro' && slide.layout !== 'links' && slide.layout !== 'ordered-list' && slide.layout !== 'unordered-list')
        traverse(slide)

    const isActive = index === activeSlide
    const backwards = lastSlide > activeSlide

    
    switch(slide.layout) {
        case 'blank':
            return <BlankSlide title={slide.title} in={isActive} backwards={backwards} key={index}/>
        case 'intro':
            return <IntroSlide text={slide.text} in={isActive} backwards={backwards} key={index}/>
        case 'title':
            return <TitleSlide title={slide.title} subtitle={slide.subtitle} background={slide.background} logo={slide.logo} credit={slide.credit} link={slide.link} in={isActive} backwards={backwards} key={index}/>
        case 'split':
            return <SplitSlide title={slide.title} desc={slide.desc} background={slide.background} in={isActive} backwards={backwards} key={index}/>
        case 'split-reverse':
            return <SplitSlideReverse title={slide.title} desc={slide.desc} background={slide.background} in={isActive} backwards={backwards} key={index}/>
        case 'split-story':
            return <SplitSlideStory title={slide.title} desc={slide.desc} story={slide.story} background={slide.background} in={isActive} backwards={backwards} key={index}/>
        case 'split-story-reverse':
            return <SplitSlideStoryReverse title={slide.title} desc={slide.desc} story={slide.story} background={slide.background} in={isActive} backwards={backwards} key={index}/>
        case 'split-story-link':
            return <SplitSlideStoryLink title={slide.title} desc={slide.desc} story={slide.story} background={slide.background} in={isActive} backwards={backwards} key={index}/>
        case 'img':
            return <ImageSlide title={slide.title} subtitle={slide.subtitle} img={slide.img} in={isActive} backwards={backwards} key={index}/> 
        case 'links':
            return <LinksSlide text={slide.text} links={slide.links} img={slide.img} in={isActive} backwards={backwards} key={index}/>
        case 'ordered-list':
            return <ListSlide ordered title={slide.title} list={slide.list} img={slide.img} in={isActive} backwards={backwards} key={index}/>
        case 'unordered-list':
            return <ListSlide title={slide.title} list={slide.list} img={slide.img} in={isActive} backwards={backwards} key={index}/>
        case 'photographer':
            return <PhotographerSlide title={slide.title} subtitle={slide.subtitle} img={slide.img} text={slide.text} link={slide.link} in={isActive} backwards={backwards} key={index}/>
        default:
            return <BlankSlide title={'INVALID TYPE'} in={isActive} backwards={backwards} key={index}/>
    }

}

export default slideParser


// WEBPACK FOOTER //
// ./src/components/slideParser.js